// Time helpers for the Workbench. Linda logs decimal hours (0.1 steps == the
// 6-minute billing unit); the backend stores h/m/s, so we convert at the edge.

export const PRESET_HOURS = [0.1, 0.2, 0.5, 1, 2];

export function decimalToHMS(decimalHours) {
  const totalSeconds = Math.round(Number(decimalHours || 0) * 3600);
  const hours = Math.floor(totalSeconds / 3600);
  const rem = totalSeconds % 3600;
  const minutes = Math.floor(rem / 60);
  const seconds = rem % 60;
  return { hours, minutes, seconds };
}

export function hmsToDecimal(h = 0, m = 0, s = 0) {
  return (Number(h) * 3600 + Number(m) * 60 + Number(s)) / 3600;
}

/** Per-entry amount: hours rounded UP to the next billing unit × unit rate. */
export function computeAmount(decimalHours, rate, incrementMin = 6) {
  const inc = Number(incrementMin) || 6;
  const { hours, minutes, seconds } = decimalToHMS(decimalHours);
  const totalMin = hours * 60 + minutes + Math.ceil(seconds / 60);
  const units = Math.ceil(totalMin / inc);
  return (units * (Number(rate) || 0) * inc) / 60;
}

/** Round to the nearest 0.1 hour for tidy preset accumulation. */
export function roundTenth(v) {
  return Math.round(Number(v || 0) * 10) / 10;
}

export function formatHours(decimal) {
  return `${Number(decimal || 0).toFixed(1)} h`;
}
